/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MeanCurrent } from './meanCurrent';


export interface StatusCodeValueMeanCurrent { 
    value?: MeanCurrent;
    status_code?: number;
}

